<template>
  <ob-modal2 :width="800" :show.sync="openModal" :backdrop="false">
    <template slot="modal-title">
      Update Question
    </template>

    <template slot="modal-body" class="modal-pad">
      <template v-if="spinnerAddQuestion">
        <ob-spinner ></ob-spinner>
      </template>
		  <template v-else>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Question*</label>
              <!-- <span v-if="!qa.CanDelete" v-tooltip="'You don\'t have permission to edit this question'"> <textarea placeholder="Enter Question"  :disabled="qa.CanDelete ? false : true" class="textarea-height" v-model="updateQuestionData.QuestionTitle" v-bind:class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.QuestionTitle.$error }"></textarea></span>
              <span v-else ><textarea placeholder="Enter Question" :disabled="qa.CanDelete ? false : true" class="textarea-height" v-model="updateQuestionData.QuestionTitle" v-bind:class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.QuestionTitle.$error }"></textarea></span>
              <span class="ob-vuelidate_error-msg" v-if="$v.updateQuestionData.QuestionTitle.$dirty && !$v.updateQuestionData.QuestionTitle.required">Please enter Question Title</span>
            -->
            <span><textarea placeholder="Enter Question" class="textarea-height" v-model="updateQuestionData.QuestionTitle" v-bind:class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.QuestionTitle.$error }"></textarea></span>
            <span class="ob-vuelidate_error-msg" v-if="$v.updateQuestionData.QuestionTitle.$dirty && !$v.updateQuestionData.QuestionTitle.required">Please enter Question Title</span>      
          </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Answer*</label>
              <medium-editor :options="editorOptions" :text="updateQuestionData && updateQuestionData.Answer ? updateQuestionData.Answer : ''" @edit='processEditOperation' custom-tag='div' :class="{ 'medium-editor-element' : true, 'ob-vuelidate_input-error': $v.updateQuestionData.Answer.$error }"></medium-editor>
              <span class="ob-vuelidate_error-msg" v-if="$v.updateQuestionData.Answer.$dirty && !$v.updateQuestionData.Answer.required">Please enter Answer</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Question Category*</label>
               <!-- <ob-select2 :options="questionCategoryOption" :disabled="qa.CanDelete ? false : true" v-if="!qa.CanDelete" v-tooltip="'You don\'t have permission to edit this question category'"  v-model="updateQuestionData.Category" :class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.Category.$error }"></ob-select2>
               <ob-select2 :options="questionCategoryOption" :disabled="qa.CanDelete ? false : true" v-else v-model="updateQuestionData.Category" :class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.Category.$error }"></ob-select2>
              <span class="ob-vuelidate_error-msg" v-if="$v.updateQuestionData.Category.$dirty && !$v.updateQuestionData.Category.required">Please Select Question Category</span> -->
               <ob-select2 :options="questionCategoryOption" :inModal="true" v-model="updateQuestionData.Category" :class="{ 'ob-vuelidate_input-error': $v.updateQuestionData.Category.$error }"></ob-select2>
               <span class="ob-vuelidate_error-msg" v-if="$v.updateQuestionData.Category.$dirty && !$v.updateQuestionData.Category.required">Please Select Question Category</span>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <ob-checkbox v-model="attachDocument" :val="true">Attach related document to this question</ob-checkbox>
            </div>
          </div>
        </div>
        <div class="row" v-if="attachDocument">
          <div class="col-md-12">
            <div class="form-group col-md-12">
                <label>Upload Document</label><span>*</span>
                <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                <ob-upload-new :validation="Validation" :end-point="EndPoint" @file-complete="onFileComplete" @remove-file="updateQuestionData.AttachmentUrl = ''" :type="2" :IsFileExists="updateQuestionData.AttachmentUrl | URL2FileName" :isUploading.sync="isUploading" ref="uploadDocument1">
                    <template slot="file-text">
                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop   OR   Choose File
                    </template>
                </ob-upload-new>
                <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                v-if="isErrorMessageDisabled && $refs.uploadDocument1.Errors.length==0" >{{errorMessageFrmResponse}} </span>
                <span class="ob-vuelidate_error-msg" v-else-if="$v.updateQuestionData.AttachmentUrl.$dirty && !$v.updateQuestionData.AttachmentUrl.required">Please upload the document</span>
            </div>
          </div>
        </div>
	    </template>
    </template>
    <template slot="modal-footer" v-if="!spinnerAddQuestion">
      <!-- Workaround for showing tooltip when the buttons are disabled-->
      <template v-if="isUploading">
        <ob-button type="secondary" :disabled="isUploading">
          <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">Cancel</span>
        </ob-button>
        <ob-button type="primary" :disabled="isUploading">
          <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">Update</span>
        </ob-button>
      </template>
      <template v-else>
        <ob-button type="secondary" @click="openModal=false">Cancel</ob-button>
        <ob-button type="primary" @click="updateQuestion(updateQuestionData)">Update</ob-button>
      </template>
    </template>
  </ob-modal2>
</template>
<script>
import c from '@/components/Core/constants.js'
import editor from "vue2-medium-editor";
import FDNSQuestionAns from "../FDNSQuestionAndAnswer.vue";
import {
  required,
  requiredIf,
  maxLength,
  alpha,
  email,
  minValue
} from "vuelidate/lib/validators";
export default {
  props: ["show", "qa"],
  data() {
    return {
      Validation: {
          Rules: {
              Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
              Size: 110000000 // In Bytes
          },
          Messages: {
              Type: "Please upload valid file formats",
              Size: `Please upload a file which is less than 100MB`
          }
      },
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachDocument: false,
      isUploading: false,
      errorMessageFrmResponse:'',
      isErrorMessageDisabled: false,
      editorOptions: {
        placeholder: {
          text: "Enter Answer"
        },
        paste: {
          forcePlainText: false,
          cleanPastedHTML: false
        }
      },
      categorySelectData: "",
      spinnerAddQuestion: false,
      spinnerEmployeerName: false,
      changeEmployeerData: "",
      dataEmployeerNameDteails: "",
      questionCategoryOption: {
        placeholder: {
          id: "-1",
          text: "Question Category"
        },
        data: []
      },
      updateQuestionData: {
        QuestionTitle: "",
        Answer: "",
        Category: "",
        AttachmentUrl: null
      },
      openModal: ""
    };
  },
  created() {
    this.openModal = this.show;
  },
  watch: {
    qa(val){
     console.log(val)
      if(qa.CanDelete)
        isActive = false
      else
        isActive = true

    },

    show(val) {
      this.openModal = val;
    },
    openModal(val) {
      this.$emit("update:show", val);
      if (val == true) {
        let cqa = __.cloneDeep(this.qa);
        this.updateQuestionData = {
          QuestionTitle: cqa.Question,
          Answer: cqa.Answer,
          Category: cqa.QuestionCategory.Id,
          AttachmentUrl: cqa.AttachementUrl
        };
        if(cqa.AttachementUrl && cqa.AttachementUrl != '') {
          this.attachDocument = true
        }
        this.categoryData();
      }
      if (val == false) {
        this.$v.updateQuestionData.$reset();
        this.updateQuestionData = {
          QuestionTitle: "",
          Answer: "",
          Category: "",
          AttachmentUrl: ""
        };
      }
    }
  },
  validations() {
    return {
      updateQuestionData: {
        QuestionTitle: {
          required
        },
        Answer: {
          required
        },
        Category: {
          required
        },
        AttachmentUrl: {
          required: requiredIf(() => {
            return this.attachDocument
          })
        }
      }
    };
  },
  components: {
    "medium-editor": editor
  },
  methods: {
    onFileComplete(fileQueue) {
      if (fileQueue[0].response.Url) {
        this.updateQuestionData.AttachmentUrl = fileQueue[0].response.Url
        this.isErrorMessageDisabled=false
      }
      if (fileQueue[0].response.State==false && fileQueue[0].response.Message!=null)
      {
        this.$refs.uploadDocument1.CancelUpload()
        this.isErrorMessageDisabled=true
        this.errorMessageFrmResponse=fileQueue[0].response.Message
      }
    },
    processEditOperation(operation) {
      let text = operation.api.origElements.innerHTML;
      // Hot Fix
      // Since the original repo has this open issue
      // https://codesandbox.io/s/v841qqzmy7
      if(text == "<p><br></p>") {
        this.updateQuestionData.Answer = "";
      } else {
        this.updateQuestionData.Answer = operation.api.origElements.innerHTML;
      }
    },
    updateQuestion(r) {
      this.$v.updateQuestionData.$touch();
      if (this.$v.updateQuestionData.$invalid != true) {
        this.$loading({ loadingText: "Updating..." });
        let params = {
          Id: this.qa.Id,
          Answer: r.Answer,
          QuestionTitle: r.QuestionTitle
        };

        // Question Category
        let qcIndex = this.categorySelectData.findIndex(
          c => c.Id == r.Category
        );
        let categoryData = this.categorySelectData[qcIndex];
        params.Category = {
          Id: categoryData.Id,
          Name: categoryData.Name
        };


        // Attachment
        if(this.attachDocument) {
          params.DocumentUrl = r.AttachmentUrl
        }

        let url = `/FDNSAudit/UpdateQuestionAnswer?empOrgId=`
        if(this.isConsultant) {
          url += this.$store.getters.getFDNSEmpOrgId
        } else {
          url += `''`
        }

        ajax.put(url, params, res => {
          this.$loading({}).close();
          if (res.data.State == true) {
              this.openModal = false;
              // Defer 300 ms to let the modal close
              setTimeout(()=>{
                  this.$message({
                      type: "success",
                      message: "Question updated Successfully"
                  });
                  let updatedData = __.cloneDeep(this.qa);
                  updatedData.Question = r.QuestionTitle;
                  updatedData.Answer = r.Answer;
                  updatedData.QuestionCategory = categoryData;
                  if(this.attachDocument) {
                      updatedData.AttachementUrl = r.AttachmentUrl
                  }
                  // TODO::sync the data, instead of complete section reload
                  this.$emit("update:qa", updatedData);
              },310)

          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        });
      }
    },
    categoryData() {
      this.spinnerAddQuestion = true;
      let url = `/FDNSAudit/GetQuestionCategoryList?empOrgId=`
      if(this.isConsultant) {
        url += this.$store.getters.getFDNSEmpOrgId
      } else {
        url += this.loggedInUserObj.OrgId
      }

      ajax.get(
        url,
        {},
        res => {
          if (res.data.State == true) {
            this.categorySelectData = res.data.FdnsModel;
            this.questionCategoryOption.data = __.map(res.data.FdnsModel, t => {
              return { id: t.Id, text: t.Name };
            });
          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
          this.spinnerAddQuestion = false;
        }
      );
    }
  }
};
</script>
<style>
textarea {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  width: 100%;
  height: 90px;
  resize: none;
  color: #555555;
}

.modal-pad {
  padding: 35px;
}

.questiontypebase {
  margin-top: 0px;
}

.ob-margin-no {
  margin-top: 15px;
}

.name-txt {
  color: #30303f;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

textarea.ob-vuelidate_input-error {
  border: 1px solid #d60000 !important;
}
.textarea-height {
  height: 60px;
  padding: 6px 12px;
}
.textarea-height:disabled, .select2-container--disabled .select2-selection{
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNS-PopUp/UpdateQuestionPopup.vue